import React from "react";
import { Box, Button, Chip, Typography } from "@mui/material";
import { Search as SearchIcon } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import NbaHotPlayersRow from "../../components/home/NbaHotPlayersRow";
import NbaAllTimeGreatsEntry from "../../components/home/NbaAllTimeGreatsEntry";
import NbaTeamsRow from "../../components/home/NbaTeamsRow";
import TriviaChallenge from "../../components/home/TriviaChallenge";
import TodaysDebateSection from "../../components/community/TodaysDebateHero";
import CommunityModule from "../../components/home/CommunityModule";
import { colors } from "../../theme";
import {
  BRAND_COLORS,
  brandOutlinedButtonSx,
  brandRgba,
} from "../../utils/brandAssets";
import {
  NBA_COMPARE_PRESETS,
  getNbaComparePath,
} from "../../adapters/nbaPlayerAdapter";

const NbaHome = () => {
  const navigate = useNavigate();

  return (
    <Box sx={{ py: { xs: 1, sm: 2 }, maxWidth: 1200, mx: "auto" }}>
      <Box sx={{ mb: 4 }}>
        <Typography variant="overline" color="text.secondary" sx={{ letterSpacing: "0.16em" }}>
          stats.fan / NBA
        </Typography>
        <Typography variant="h3" component="h1" fontWeight={800} sx={{ mt: 0.5 }}>
          Basketball stats hub
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mt: 1, maxWidth: 560 }}>
          Career leaders and player search powered by our full NBA archive — 5,400+
          players from the modern era.
        </Typography>
        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1.5, mt: 2 }}>
          <Button
            variant="outlined"
            startIcon={<SearchIcon />}
            onClick={() => navigate("/app/nba/players")}
            sx={brandOutlinedButtonSx}
          >
            Search players
          </Button>
          <Button
            variant="outlined"
            onClick={() => navigate("/app/nba/teams")}
            sx={brandOutlinedButtonSx}
          >
            Browse teams
          </Button>
          <Button
            variant="outlined"
            onClick={() => navigate("/app/nba/queryBuilder")}
            sx={brandOutlinedButtonSx}
          >
            Stat Explorer
          </Button>
        </Box>
      </Box>

      <TriviaChallenge sport="nba" />
      <TodaysDebateSection sport="nba" />
      <CommunityModule sport="nba" />
      <Box sx={{ mb: 4 }}>
        <Typography variant="h6" fontWeight={700} sx={{ mb: 1 }}>
          Compare players
        </Typography>
        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
          {NBA_COMPARE_PRESETS.map((preset) => (
            <Chip
              key={preset.label}
              label={preset.label}
              clickable
              variant="outlined"
              onClick={() => navigate(getNbaComparePath(preset.players))}
              sx={{
                borderColor: colors.border,
                "&:hover": {
                  borderColor: BRAND_COLORS.cyan,
                  backgroundColor: brandRgba(BRAND_COLORS.cyan, 0.08),
                },
              }}
            />
          ))}
        </Box>
      </Box>

      <NbaTeamsRow />
      <NbaHotPlayersRow />
      <NbaAllTimeGreatsEntry />
    </Box>
  );
};

export default NbaHome;
